import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/users.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { MessageService } from 'primeng/api';
// import { SidebarComponent } from 'src/app/components';
import { FormBuilder } from '@angular/forms';
import * as e from 'express';
import { STICKY_MESSAGE_SERVICE_PROVIDER } from 'src/app/services/sticky-message.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [STICKY_MESSAGE_SERVICE_PROVIDER]
})
export class LoginComponent implements OnInit {
  protected aFormGroup: FormGroup;
  constructor(
    private messageService: MessageService,
    private authService: AuthService,
    public userService: UserService,
    // private sidebarService: SidebarComponent,
    private formBuilder: FormBuilder,
    // private authService: AuthenticationService
    public router: Router) {
      
  }
  siteKey: string = "6Lfyv0wpAAAAAHJ3aQoXtTWsBG-0FdkPig844Zd3";
  loading: boolean = true;
  imadataLogo = 'assets/logos/imadata-logo.png';
  loginForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  errorMsg!: Message[];
  role: any;

  async ngOnInit(){
    this.authService.isLoginPage = true;
    await Promise.all([
      this.loading = true,
      this.validationOfToken(),
      this.aFormGroup = this.formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required],
        recaptcha: ['', Validators.required]
      })
    ]);
  }

  ngOnDestroy() {
    this.authService.isLoginPage = false;
  }

  login() {
    this.loading = true;
    const user = {email: this.aFormGroup.value.email, password: this.aFormGroup.value.password};
    if (this.aFormGroup.value.recaptcha == '') {
      this.loading = false;
      this.showError('Por favor, confirme que no es un robot');
      return;
    }
    this.userService.login(user).subscribe({
      next: (response: any) => {
        localStorage.setItem('token', JSON.stringify(response.token));
        localStorage.setItem('redLink', JSON.stringify(response.user.link_redirection));
        this.authService.login();
      },
      error: (error: any) => {
        this.loading = false;
        this.showError('Usuario o contraseña incorrectos');
        console.log(error);
        if (error.code == 401) {
          this.showWarning('Usuario o contraseña incorrectos');
        } else {
          this.showError('Error inesperado');
        }
      }
    });
  }

  async validationOfToken() {
    this.loading = true;
    this.userService.me().subscribe({
      next: (response: any) => {
        this.router.navigate([response.link_redirection]);
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        console.log(error);
      }
    });
  }

  showError(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  showWarning(message: string) {
    this.messageService.add({ severity: 'warning', summary: message });
  }
}
